/** localStorage helpers — same `spg.*` keys as the design prototype. */

export function load<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem("spg." + key);
    return v === null ? fallback : (JSON.parse(v) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, val: unknown): void {
  try {
    localStorage.setItem("spg." + key, JSON.stringify(val));
  } catch {
    /* quota/private mode — ignore */
  }
}
